// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ahz5","type":"styles_type__1CiC3","choices":"styles_choices__2skQr"};